module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/fv-voice-pc-f7d396e203d1591b9c034b88b7d03126.png";